jQuery(function () {

    var searchWrapper = $("#search-wrapper-id");
    var clickTimeout = null;

    //var scrollTimeout = null;
    var resizeTimeout = null;

    var elemsHeight = $(".header").height() + $(".breadcrumbs-cont").height() + $(".result-header").height(); //+ $(".result-pagination").height();
    var globalSearchHeight = $(window).height() - elemsHeight;

    var privateFunctions = {
        mapExists: function () {
            return $("#search-rbnb-map").length > 0;
        },
        calcStickyMap: function () {
            var marginInPx = $('.header-wrapper .header').height();

            // scroll effect on Large Screens
            if (Foundation.MediaQuery.current == "large") {
                var marginInPxNew = $('.header-wrapper .header .main-nav').height() + 12;
                marginInPx = marginInPxNew;
            }
            // scroll effect on Large Screens - END

            var marginInEm = marginInPx / parseFloat($("body").css("font-size"));

            var moduleId = "#search-rbnb-map";

            $(`${moduleId} .sticky`).attr('data-margin-top', marginInEm).data('margin-top', marginInEm);
            $(`${moduleId} .sticky`).css('height', `calc(100vh - ${marginInPx}px)`);
            $(`${moduleId} .sticky`).css('min-height', `calc(100vh - ${marginInPx}px)`);

            if ($(`${moduleId} .sticky`).attr('data-sticky')) {
                $(`${moduleId} .sticky`).data('zfPlugin').options.marginTop = marginInEm;
                $(`${moduleId} .sticky`).foundation('_calc', true, 100); // 100 is just a random number, I do not know why it only works 100% of the time, if a number is provided
            } else {
                $(`${moduleId} .sticky`).attr('data-sticky', 'true').foundation();
            }

            if (!!ppcartoStatic && !!ppcartoStatic.$refs && !!ppcartoStatic.$refs.static && !!ppcartoStatic.$refs.static.map) {
                ppcartoStatic.$refs.static.map._onResize();
            }
        },
        resizeMap: function () {
            var scrollTop = $(window).scrollTop();
            var marginInPx = $('.header-wrapper .header').height();

            // scroll effect on Large Screens
            if (Foundation.MediaQuery.current == "large") {
                var marginInPxNew = $('.header-wrapper .header .main-nav').height() + 12;
                marginInPx = marginInPxNew;
            }
            // scroll effect on Large Screens - END

            scrollTop = $(window).scrollTop() + marginInPx;
            var mapTop = $("#search-rbnb-map").offset().top;

            var currentHeight = $(`#search-rbnb-map .sticky`).height();

            var height = 0; //just so we initialize the variable 

            if (mapTop <= scrollTop) {
                $(`#search-rbnb-map .sticky`).css('height', `calc(100vh - ${marginInPx}px)`);
                $(`#search-rbnb-map .sticky`).css('min-height', `calc(100vh - ${marginInPx}px)`);

                height = $(`#search-rbnb-map .sticky`).height();

                if (currentHeight != height) {
                    if (!!ppcartoStatic && !!ppcartoStatic.$refs && !!ppcartoStatic.$refs.static && !!ppcartoStatic.$refs.static.map) {
                        ppcartoStatic.$refs.static.map._onResize();
                    }
                }

                return;
            }

            var bottomTop = $(window).scrollTop() + $(window).height();
            height = bottomTop - mapTop;
            $(`#search-rbnb-map .sticky`).css('height', `${height}px`);
            $(`#search-rbnb-map .sticky`).css('min-height', `${height}px`);

            if (currentHeight != height) {
                if (!!ppcartoStatic && !!ppcartoStatic.$refs && !!ppcartoStatic.$refs.static && !!ppcartoStatic.$refs.static.map) {
                    ppcartoStatic.$refs.static.map._onResize();
                }
            }

        },
        mapGlobalSearchExists: function () {
            return $("#global-search-rbnb-map").length > 0;
        },
        calcGlobalSearchMap: function () {
            if (typeof ppcartoStatic !== 'undefined' && !!ppcartoStatic && !!ppcartoStatic.$refs && !!ppcartoStatic.$refs.static && !!ppcartoStatic.$refs.static.map) {
                ppcartoStatic.$refs.static.map.resize();//._onResize();
            }
        }
    }

    $(window).on("load", function () {
        //equalHeight($("#search-wrapper-id .search-result-item"), true);

        $(".search-wrapper").each(function(){
            var $this = $(this);

            if($this.is(":visible")){
                equalHeight($this.find(".search-result-item"), true);
            }
        });


        if (privateFunctions.mapExists()) {
            privateFunctions.calcStickyMap();
            privateFunctions.resizeMap();
        } else if (privateFunctions.mapGlobalSearchExists()) {
            let hasClass = $(".global-search-rbnb-map-wrapper").hasClass("in-foreground");
            let minHeight = $(".global-search-rbnb-map-wrapper").addClass("in-foreground").css('min-height');
            minHeight = parseInt(minHeight);
            if (!hasClass)
                $(".global-search-rbnb-map-wrapper").removeClass("in-foreground");
            if (!!minHeight && globalSearchHeight < minHeight)
                globalSearchHeight = minHeight;

            $(".global-search-rbnb-map-wrapper").height(globalSearchHeight);
            privateFunctions.calcGlobalSearchMap();
        } else {}
    });
    $(window).on("orientationchange resize", function () {
        if (!!resizeTimeout) {
            clearTimeout(resizeTimeout);
        }
        resizeTimeout = setTimeout(function () {
            //equalHeight($("#search-wrapper-id .search-result-item"), true);

            $(".search-wrapper").each(function(){
                var $this = $(this);

                if($this.is(":visible")){
                    equalHeight($this.find(".search-result-item"), true);
                }
            });

            if (privateFunctions.mapExists()) {
                privateFunctions.calcStickyMap();
            } else if (privateFunctions.mapGlobalSearchExists()) {
                privateFunctions.calcGlobalSearchMap();
            } else {}

            resizeTimeout = null;
        }, 300);
    });
    $(window).on("scroll", function () {
        if (privateFunctions.mapExists()) {
            privateFunctions.resizeMap();
        } else if (privateFunctions.mapGlobalSearchExists()) {
            privateFunctions.calcGlobalSearchMap();
        } else {}
    });

    $(".search-results").off("click",".switch-to-map").on("click", ".switch-to-map", function (e) {
        e.preventDefault();


        if (!!clickTimeout) {
            clearTimeout(clickTimeout);
        }

        clickTimeout = setTimeout(function () {
            var $target = $(e.target).closest(".switch-to-map");

            $("#search-wrapper-id .result-display-wrapper .search-results").toggleClass("in-foreground");

            if (!!$target.data("alternative-text")) {
                var currentText = $target.html();
                var textToReplace = $target.data("alternative-text");
                $target.data("alternative-text", currentText);
                $target.html(textToReplace);
            }

            if (privateFunctions.mapExists()) {
                $("#search-rbnb-map").toggleClass("in-foreground");
            } else if (privateFunctions.mapGlobalSearchExists()) {
                $("#global-search-rbnb-map").toggleClass("in-foreground");

                if ($("#global-search-rbnb-map").hasClass("in-foreground")) {
                    $(".global-search .search-wrapper .search").height(globalSearchHeight);

                    $('html, body').animate({
                        scrollTop: $(".searchPage").offset().top - $('.header-wrapper .header').height() - 16
                    }, 800);
                } else {
                    $(".global-search .search-wrapper .search").removeAttr('style');
                }
            }

            if (!!ppcartoStatic && !!ppcartoStatic.$refs && !!ppcartoStatic.$refs.static && !!ppcartoStatic.$refs.static.refitBounds) {
                ppcartoStatic.$refs.static.refitBounds();
            }

            window.pixelpoint.tagManager.event("moduleClicked", {
                "modulename": "Search Results",
                "suche-karte": "true",
                "view": $target.data("alternative-text")
            });
        }, 200);
    });

    $(".search-categories-list").on("click", "a.accordion-title", function (e) {
        var $target = $(e.target).closest("a.accordion-title");

        var categoryName = $target.contents().filter(function () {
            return this.nodeType == 3;
        })[0].nodeValue;

        window.pixelpoint.tagManager.event("moduleClicked", {
            "modulename": "Search Results",
            "kategorie": "true",
            "kategorie-name": categoryName
        });
    });

    $(window).on('load', function () {
        if (searchWrapper.length == 0)
            return;
        let limit = 100;
        let loadFeatures = () => {
            var features = window.pixelpoint.airBnB.getFeatures();
            if (!!features && features.length > 0) {
                var parent = $(".result-list");
                var tiles = $(".result-list .search-result-item");
                $.each(features, function (key, feature) {
                    var index = key + 1;
                    var id = feature.id;
                    var poiType = feature.layer;
                    var searchedTile = null;
                    if(!!poiType){
                        searchedTile = tiles.filter(`[data-type="${poiType}"][data-item-id="${id}"]`).not('.indexed').first();
                    }else{
                        searchedTile = tiles.filter(`[data-item-id="${id}"]`).not('.indexed').first();
                    }
                    if (searchedTile.length == 0)
                        return true;
                    var number = searchedTile.find(".slider-wrapper p.number");
                    if (number.length > 0) {
                        number.text(index);
                    } else {
                        searchedTile.find(".slider-wrapper").append(`<p class="number">${index}</p>`);
                    }
                    searchedTile.addClass("indexed");
                    parent.append(searchedTile);
                });
            }
            else{
                if(limit > 0){                    
                    setTimeout(() => {
                        loadFeatures();
                    },100);
                }
            }
            limit--;
        };
        loadFeatures();
    });

});